// Mock data for waterproofing company website
// Note: testimonials and governmentProjects are now served from backend API

export const stats = [
  { label: 'Years of Experience', value: '26+', icon: 'award' },
  { label: 'Square Feet Covered', value: '10M+', icon: 'building' },
  { label: 'Homes Completed', value: '2000+', icon: 'home' },
  { label: 'Satisfied Clients', value: '5000+', icon: 'users' }
];

export const services = [
  {
    id: 1,
    title: 'Terrace Waterproofing',
    problem: 'Ceiling leakage and water seepage from terrace',
    method: 'Advanced membrane systems with proper slope correction',
    benefit: 'Long-lasting protection against monsoon damage',
    icon: 'home',
    imageUrl: 'https://customer-assets.emergentagent.com/job_leakdefense-pros/artifacts/n3aknh9f_Screenshot%202026-03-29%20at%202.30.01%E2%80%AFPM.png'
  },
  {
    id: 2,
    title: 'Basement & Foundation Waterproofing',
    problem: 'Water accumulation and dampness in basement areas',
    method: 'Crystalline waterproofing and drainage solutions',
    benefit: 'Prevents structural damage and maintains property value',
    icon: 'layers',
    imageUrl: 'https://customer-assets.emergentagent.com/job_leakdefense-pros/artifacts/a5ktjcav_Screenshot%202026-03-29%20at%202.30.21%E2%80%AFPM.png'
  },
  {
    id: 3,
    title: 'Water Tank & Sump Waterproofing',
    problem: 'Leakage causing water wastage and contamination',
    method: 'Food-grade waterproofing compounds',
    benefit: 'Safe drinking water storage with zero leakage',
    icon: 'droplet',
    imageUrl: 'https://customer-assets.emergentagent.com/job_leakdefense-pros/artifacts/47unf1l7_Screenshot%202026-03-29%20at%202.30.34%E2%80%AFPM.png'
  },
  {
    id: 4,
    title: 'Bathroom & Wet Area Waterproofing',
    problem: 'Seepage to lower floors and wall dampness',
    method: 'Chemical-resistant waterproofing with tile adhesion',
    benefit: 'Prevents damage to adjacent rooms and floors',
    icon: 'shower-head',
    imageUrl: 'https://customer-assets.emergentagent.com/job_leakdefense-pros/artifacts/fartqsu5_Screenshot%202026-03-29%20at%202.30.41%E2%80%AFPM.png'
  },
  {
    id: 5,
    title: 'External Wall & Structural Waterproofing',
    problem: 'Wall dampness and paint peeling during rains',
    method: 'Acrylic polymer coatings with breathable finish',
    benefit: 'Weather-resistant exterior with improved aesthetics',
    icon: 'shield',
    imageUrl: 'https://customer-assets.emergentagent.com/job_leakdefense-pros/artifacts/lxn8pm9n_Screenshot%202026-03-29%20at%202.30.47%E2%80%AFPM.png'
  },
  {
    id: 6,
    title: 'Government & Infrastructure Waterproofing',
    problem: 'Large-scale protection for public infrastructure',
    method: 'Compliance-grade materials with inspection standards',
    benefit: 'Durable solutions meeting government specifications',
    icon: 'building-2',
    imageUrl: 'https://customer-assets.emergentagent.com/job_leakdefense-pros/artifacts/no993bjt_ChatGPT%20Image%20Mar%2029%2C%202026%20at%2002_18_59%20PM.png'
  }
];

export const whyChooseUs = [
  {
    title: '26 Years of Field Experience',
    description: 'Decades of hands-on execution across residential and infrastructure projects',
    icon: 'calendar-check'
  },
  {
    title: 'Proven Scale of Execution',
    description: '10 million+ sq ft successfully waterproofed with lasting results',
    icon: 'trending-up'
  },
  {
    title: 'Trusted by Government Bodies',
    description: 'Multiple public infrastructure projects completed with satisfactory ratings',
    icon: 'badge-check'
  },
  {
    title: 'Long-lasting Solutions',
    description: 'Focus on permanent fixes over temporary repairs with proper warranties',
    icon: 'shield-check'
  },
  {
    title: 'Skilled Workforce',
    description: 'Trained professionals using proven methods and quality materials',
    icon: 'users-round'
  },
  {
    title: 'Compliance & Standards',
    description: 'Work meets government inspection standards and industry best practices',
    icon: 'file-check'
  }
];